import { html } from '../../mixins/katapult-element.js';
import { KatapultEditorTemplate } from './katapult-editor-template.js';
import { PortalStyle } from './katapult-model-editor-style.js';
import { CamelCase } from '../../modules/CamelCase.js';
import '@polymer/paper-toggle-button/paper-toggle-button.js';
import '../icon-picker-dialog/icon-picker-dialog';
import '../katapult-color-picker/katapult-color-picker-button.js';
import '../katapult-color-picker/katapult-color-picker-dialog.js';
import { DEFAULT_SCHEMAS } from '../../modules/KLogicSchemas.js';
import { TIME_ZONES } from '../../modules/TimeZoneDate.js';
import { addFlagListener, removeFlagListener } from '../../modules/FeatureFlags.js';

customElements.define(
  'katapult-model-options-editor',
  class extends KatapultEditorTemplate {
    static get template() {
      return html`
        ${super.style} ${PortalStyle}

        <katapult-firebase-worker path="[[modelSpaceDetails.path]]/models/attributes" data="{{otherAttributes}}">
        </katapult-firebase-worker>

        <katapult-firebase-worker path="photoheight/company_space/[[userGroup]]/models/map_styles" data="{{mapStyles}}">
        </katapult-firebase-worker>

        <icon-picker-dialog
          id="iconPickerDialog"
          model-key="[[modelSpaceDetails.$key]]"
          on-icon-selected="iconSelected"
          fit-into="[[$this]]"
        ></icon-picker-dialog>
        <katapult-color-picker-dialog></katapult-color-picker-dialog>

        <paper-table>
          <!-- Default Map Styles -->
          <paper-row expand>
            <paper-cell icon>
              <material-icon icon="style"></material-icon>
            </paper-cell>
            <paper-cell shrink column align-start style="max-width: 400px;">
              <span>Default Map Styles</span>
              <span style="font-size: 10pt;" italic
                >Note: Styles are copied to the model when chosen and are not kept in sync with the selected map styles.</span
              >
            </paper-cell>
            <paper-cell>
              <paper-table rounded outline grow dividers overflow-hidden>
                <!-- Drop Down -->
                <paper-row>
                  <paper-cell>
                    <katapult-drop-down
                      label="Select a Map Style"
                      items="[[mapStyles]]"
                      value="[[_itemData.map.default_map_styles._key]]"
                      value-path="$key"
                      label-function="[[getMapStyleLabel]]"
                      no-label-float
                      on-selected-changed="mapStyleChangedCallback"
                    ></katapult-drop-down>
                  </paper-cell>
                </paper-row>
              </paper-table>
            </paper-cell>
          </paper-row>

          <!-- Default Map Labels -->
          <paper-row expand>
            <paper-cell icon>
              <material-icon icon="map"></material-icon>
            </paper-cell>
            <paper-cell shrink>Default Map Labels</paper-cell>
            <paper-cell>
              <paper-table rounded outline grow dividers overflow-hidden>
                <!-- Header -->
                <paper-row grey short>
                  <paper-cell>Attribute</paper-cell>
                  <paper-cell icon></paper-cell>
                </paper-row>
                <!-- Body -->
                <template is="dom-repeat" items="[[getItemsArray(_itemData.map.default_labels.*, $true)]]" mutable-data>
                  <paper-row>
                    <paper-cell>[[camelCase(item.$key)]]</paper-cell>
                    <paper-cell icon-button>
                      <katapult-button
                        iconOnly
                        noBorder
                        icon="delete"
                        data-path="_itemData.map.default_labels.$(model.item.$key)"
                        data-value="$null"
                        on-click="updateProperty"
                      ></katapult-button>
                    </paper-cell>
                  </paper-row>
                </template>
                <!-- Add Drop Down -->
                <paper-row>
                  <paper-cell>
                    <katapult-drop-down
                      label="Select an Attribute"
                      items="[[otherAttributes]]"
                      value-path="$key"
                      label-path="$key"
                      label-function="[[camelCase]]"
                      no-label-float
                      data-path="_itemData.map.default_labels.$(detail.value)"
                      data-value="$true"
                      on-selected-changed="selectedChangedCallback"
                    ></katapult-drop-down>
                  </paper-cell>
                </paper-row>
              </paper-table>
            </paper-cell>
          </paper-row>

          <!-- Round Map Labels -->
          <paper-row expand checkbox pointer>
            <paper-cell icon>
              <material-icon icon="straighten"></material-icon>
            </paper-cell>
            <paper-cell shrink>Round Map Labels Up to Nearest Foot</paper-cell>
            <paper-cell icon>
              <paper-checkbox
                checked="[[_itemData.map.round_distances_up]]"
                data-path="_itemData.map.round_distances_up"
                on-change="toggleProperty"
              ></paper-checkbox>
            </paper-cell>
          </paper-row>

          <!-- Default Mobile Map Labels -->
          <paper-row expand>
            <paper-cell icon>
              <material-icon icon="smartphone"></material-icon>
            </paper-cell>
            <paper-cell shrink>Default Mobile Map Labels</paper-cell>
            <paper-cell>
              <paper-table rounded outline grow dividers overflow-hidden>
                <!-- Header -->
                <paper-row grey short>
                  <paper-cell>Attribute</paper-cell>
                  <paper-cell icon></paper-cell>
                </paper-row>
                <!-- Body -->
                <template is="dom-repeat" items="[[getItemsArray(_itemData.mobile.default_labels.*, $true)]]" mutable-data>
                  <paper-row>
                    <paper-cell>[[camelCase(item.$key)]]</paper-cell>
                    <paper-cell icon-button>
                      <katapult-button
                        iconOnly
                        noBorder
                        icon="delete"
                        data-path="_itemData.mobile.default_labels.$(model.item.$key)"
                        data-value="$null"
                        on-click="updateProperty"
                      ></katapult-button>
                    </paper-cell>
                  </paper-row>
                </template>
                <!-- Add Drop Down -->
                <paper-row>
                  <paper-cell>
                    <katapult-drop-down
                      label="Select an Attribute"
                      items="[[otherAttributes]]"
                      value-path="$key"
                      label-path="$key"
                      label-function="[[camelCase]]"
                      no-label-float
                      data-path="_itemData.mobile.default_labels.$(detail.value)"
                      data-value="$true"
                      on-selected-changed="selectedChangedCallback"
                    ></katapult-drop-down>
                  </paper-cell>
                </paper-row>
              </paper-table>
            </paper-cell>
          </paper-row>

          <!-- Default Photo Labels -->
          <paper-row expand>
            <paper-cell icon>
              <material-icon icon="photo"></material-icon>
            </paper-cell>
            <paper-cell shrink>Default Photo Labels</paper-cell>
            <paper-cell>
              <paper-table rounded outline grow dividers overflow-hidden>
                <!-- Header -->
                <paper-row grey short>
                  <paper-cell>Attribute</paper-cell>
                  <paper-cell icon></paper-cell>
                </paper-row>
                <!-- Body -->
                <template is="dom-repeat" items="[[getItemsArray(_itemData.photofirst.default_labels.*, $true)]]" mutable-data>
                  <paper-row>
                    <paper-cell>[[camelCase(item.$key)]]</paper-cell>
                    <paper-cell icon-button>
                      <katapult-button
                        iconOnly
                        noBorder
                        icon="delete"
                        data-path="_itemData.photofirst.default_labels.$(model.item.$key)"
                        data-value="$null"
                        on-click="updateProperty"
                      ></katapult-button>
                    </paper-cell>
                  </paper-row>
                </template>
                <!-- Add Drop Down -->
                <paper-row>
                  <paper-cell>
                    <katapult-drop-down
                      label="Select an Attribute"
                      items="[[otherAttributes]]"
                      value-path="$key"
                      label-path="$key"
                      label-function="[[camelCase]]"
                      no-label-float
                      data-path="_itemData.photofirst.default_labels.$(detail.value)"
                      data-value="$true"
                      on-selected-changed="selectedChangedCallback"
                    ></katapult-drop-down>
                  </paper-cell>
                </paper-row>
              </paper-table>
            </paper-cell>
          </paper-row>

          <!-- Node Counter Logic -->
          <paper-row expand>
            <paper-cell icon>
              <material-icon icon="functions"></material-icon>
            </paper-cell>
            <paper-cell shrink column align-start style="max-width: 400px;">
              <span>Node Counter Logic</span>
              <span style="font-size: 10pt;" italic>
                Define custom logic that results in a value of "TRUE" for nodes that should be included in the completed counter.</span
              >
            </paper-cell>
            <paper-cell>
              <paper-table rounded outline grow dividers overflow-hidden>
                <paper-row style="height: auto">
                  <paper-cell>
                    <k-logic-editor id="editor" schema="[[computeSchema()]]" block="{{_itemData.logic}}"></k-logic-editor>
                  </paper-cell>
                </paper-row>
              </paper-table>
            </paper-cell>
          </paper-row>

          <!-- Admins Only -->
          <paper-row expand checkbox pointer>
            <paper-cell icon>
              <material-icon icon="lock"></material-icon>
            </paper-cell>
            <paper-cell shrink>Only Allow Admins To Edit This Model</paper-cell>
            <paper-cell icon>
              <paper-toggle-button checked="{{_itemData.model_editor.admins_only}}"></paper-toggle-button>
            </paper-cell>
          </paper-row>

          <!-- Default Map Layer Icon -->
          <template is="dom-if" if="[[enabledFeatures.configurable_kmz_icon_fallback]]">
            <paper-row expand checkbox pointer>
              <paper-cell icon>
                <material-icon icon="layers"></material-icon>
              </paper-cell>
              <paper-cell shrink column align-start style="max-width: 400px;">
                <span>Default Map Layer Icon</span>
                <span style="font-size: 10pt;" italic>
                  If you import a map layer with a unknown icon, it will default to using the icon you set here.
                </span>
              </paper-cell>
              <template is="dom-if" if="[[_itemData.map.map_layers_default_icon.icon]]">
                <paper-cell
                  shrink
                  column
                  align-start
                  style="max-width: 400px; display:flex; flex-direction: row; width: 100%; align-item: center"
                >
                  <iron-icon
                    name="[[_itemData.map.map_layers_default_icon.icon]]"
                    icon="[[_itemData.map.map_layers_default_icon.icon]]"
                    style$="color:[[_itemData.map.map_layers_default_icon.color]]; cursor:pointer; padding: 5px;"
                    on-click="openIconDialog"
                  ></iron-icon>
                  <katapult-color-picker-button
                    style="display:inline-block;margin:0 0 0 8px;"
                    color="[[_itemData.map.map_layers_default_icon.color]]"
                    on-color-changed="iconColorChanged"
                  ></katapult-color-picker-button>
                </paper-cell>
              </template>
              <template is="dom-if" if="[[!_itemData.map.map_layers_default_icon.icon]]">
                <paper-cell shrink column align-start style="max-width: 400px;">
                  <katapult-button on-click="openIconDialog" style="margin-left: 8px;" size="20" color="var(--secondary-color)">
                    Choose Icon
                  </katapult-button>
                </paper-cell>
              </template>
            </paper-row>
          </template>

          <!-- Model Time Zone -->
          <paper-row expand>
            <paper-cell icon>
              <material-icon icon="schedule"></material-icon>
            </paper-cell>
            <paper-cell shrink column align-start style="max-width: 400px;">
              <span>Model Time Zone</span>
              <span style="font-size: 10pt;" italic
                >When a model is configured with a time zone, all "Date" type attributes will save and display dates at midnight of the
                specified time zone.</span
              >
            </paper-cell>
            <paper-cell>
              <paper-table rounded outline grow dividers overflow-hidden>
                <!-- Drop Down -->
                <paper-row>
                  <paper-cell>
                    <katapult-drop-down
                      label="Select a Time Zone"
                      items="[[TIME_ZONES]]"
                      value="{{_itemData.time_zone}}"
                      no-label-float
                    ></katapult-drop-down>
                  </paper-cell>
                </paper-row>
              </paper-table>
            </paper-cell>
          </paper-row>
          <!-- Address Tool Config -->
          <template is="dom-if" if="[[enabledFeatures.address_tool_model_configurable]]">
            <paper-row expand>
              <paper-cell icon>
                <material-icon icon="edit_location"></material-icon>
              </paper-cell>
              <paper-cell shrink column align-start style="max-width: 400px;">
                <span>Customize Address Tool</span>
                <span style="font-size: 10pt;" italic
                  >Select the attributes you would like the address tool to write data into. If not configured data will populate into the
                  default attribute.
                </span>
              </paper-cell>
              <paper-cell style="max-width: 200px;">
                <paper-toggle-button checked="{{_itemData.map.address_attributes.duplicate_attributes}}"
                  >Write Data to Both Attributes</paper-toggle-button
                >
              </paper-cell>
              <paper-cell>
                <paper-table rounded outline grow dividers overflow-hidden>
                  <!-- Header -->
                  <paper-row grey short>
                    <paper-cell>Default Attribute</paper-cell>
                    <paper-cell>Write Data to Attribute</paper-cell>
                  </paper-row>
                  <paper-row>
                    <paper-cell> Street Number </paper-cell>
                    <paper-cell>
                      <katapult-drop-down
                        label="Select an Attribute"
                        items="[[otherAttributes]]"
                        value-path="$key"
                        label-path="$key"
                        label-function="[[camelCase]]"
                        no-label-float
                        data-path="_itemData.map.address_attributes.street_number"
                        value="[[_itemData.map.address_attributes.street_number]]"
                        on-selected-changed="updateProperty"
                      ></katapult-drop-down>
                    </paper-cell>
                  </paper-row>
                  <paper-row>
                    <paper-cell> Street Name </paper-cell>
                    <paper-cell>
                      <katapult-drop-down
                        label="Select an Attribute"
                        items="[[otherAttributes]]"
                        value-path="$key"
                        label-path="$key"
                        label-function="[[camelCase]]"
                        no-label-float
                        data-path="_itemData.map.address_attributes.street_name"
                        value="[[_itemData.map.address_attributes.street_name]]"
                        on-selected-changed="updateProperty"
                      ></katapult-drop-down>
                    </paper-cell>
                  </paper-row>
                  <paper-row>
                    <paper-cell> Township </paper-cell>
                    <paper-cell>
                      <katapult-drop-down
                        label="Select an Attribute"
                        items="[[otherAttributes]]"
                        value-path="$key"
                        label-path="$key"
                        label-function="[[camelCase]]"
                        no-label-float
                        data-path="_itemData.map.address_attributes.township"
                        value="[[_itemData.map.address_attributes.township]]"
                        on-selected-changed="updateProperty"
                      ></katapult-drop-down>
                    </paper-cell>
                  </paper-row>
                  <paper-row>
                    <paper-cell> Municipality </paper-cell>
                    <paper-cell>
                      <katapult-drop-down
                        label="Select an Attribute"
                        items="[[otherAttributes]]"
                        value-path="$key"
                        label-path="$key"
                        label-function="[[camelCase]]"
                        no-label-float
                        data-path="_itemData.map.address_attributes.municipality"
                        value="[[_itemData.map.address_attributes.municipality]]"
                        on-selected-changed="updateProperty"
                      ></katapult-drop-down>
                    </paper-cell>
                  </paper-row>
                  <paper-row>
                    <paper-cell> County </paper-cell>
                    <paper-cell>
                      <katapult-drop-down
                        label="Select an Attribute"
                        items="[[otherAttributes]]"
                        value-path="$key"
                        label-path="$key"
                        label-function="[[camelCase]]"
                        no-label-float
                        data-path="_itemData.map.address_attributes.county"
                        value="[[_itemData.map.address_attributes.county]]"
                        on-selected-changed="updateProperty"
                      ></katapult-drop-down>
                    </paper-cell>
                  </paper-row>
                  <paper-row>
                    <paper-cell> State </paper-cell>
                    <paper-cell>
                      <katapult-drop-down
                        label="Select an Attribute"
                        items="[[otherAttributes]]"
                        value-path="$key"
                        label-path="$key"
                        label-function="[[camelCase]]"
                        no-label-float
                        data-path="_itemData.map.address_attributes.state"
                        value="[[_itemData.map.address_attributes.state]]"
                        on-selected-changed="updateProperty"
                      ></katapult-drop-down>
                    </paper-cell>
                  </paper-row>
                  <paper-row>
                    <paper-cell> Zip Code </paper-cell>
                    <paper-cell>
                      <katapult-drop-down
                        label="Select an Attribute"
                        items="[[otherAttributes]]"
                        value-path="$key"
                        label-path="$key"
                        label-function="[[camelCase]]"
                        no-label-float
                        data-path="_itemData.map.address_attributes.zip_code"
                        value="[[_itemData.map.address_attributes.zip_code]]"
                        on-selected-changed="updateProperty"
                      ></katapult-drop-down>
                    </paper-cell>
                  </paper-row>
                  <paper-row>
                    <paper-cell> Address (Formatted Address) </paper-cell>
                    <paper-cell>
                      <katapult-drop-down
                        label="Select an Attribute"
                        items="[[otherAttributes]]"
                        value-path="$key"
                        label-path="$key"
                        label-function="[[camelCase]]"
                        no-label-float
                        data-path="_itemData.map.address_attributes.address"
                        value="[[_itemData.map.address_attributes.address]]"
                        on-selected-changed="updateProperty"
                      ></katapult-drop-down>
                    </paper-cell>
                  </paper-row>
                </paper-table>
              </paper-cell>
            </paper-row>
          </template>

          <!-- Allow Public Feedback on the Job -->
          <paper-row expand checkbox pointer>
            <paper-cell icon>
              <material-icon icon="public"></material-icon>
            </paper-cell>
            <paper-cell shrink>Allow Public Feedback on Jobs With This Model</paper-cell>
            <paper-cell icon>
              <paper-toggle-button
                checked="[[_itemData.map.allow_public_feedback]]"
                on-checked-changed="togglePublicFeedback"
              ></paper-toggle-button>
            </paper-cell>
          </paper-row>

          <!-- Delete Button -->
          <paper-row expand>
            <paper-cell>
              <katapult-button color="var(--paper-red-500)" icon="delete_forever" on-click="fireDeleteModelSpace"
                >Delete [[modelSpaceDetails.type]]</katapult-button
              >
            </paper-cell>
          </paper-row>
        </paper-table>
      `;
    }

    constructor() {
      super();
      this.camelCase = CamelCase;
      this.getMapStyleLabel = (x) => x?._name ?? CamelCase(x?.$key);
    }

    ready() {
      super.ready();
      this.appConfiguration = new AppConfiguration(this);
      this.TIME_ZONES = TIME_ZONES;
    }
    connectedCallback() {
      super.connectedCallback();

      this.addressToolModelConfigurableListener = addFlagListener('address_tool_model_configurable', (enabled) => {
        this.set('enabledFeatures.address_tool_model_configurable', enabled);
      });
    }

    disconnectedCallback() {
      super.disconnectedCallback();

      removeFlagListener('address_tool_model_configurable', this.addressToolModelConfigurableListener);
    }

    fireDeleteModelSpace() {
      this.fire('delete-model-space', null, true);
    }

    updateTopLevelInput(e) {
      let dataPath = e.currentTarget?.dataset?.path;
      // Don't update values from top level inputs until _itemData is set
      if (this._itemData && dataPath && e?.detail) {
        this.set(dataPath, e.detail.value);
      }
    }

    manageSharedAttacherLimits() {
      this.$.limitsDialog.open();
    }

    mapStyleChangedCallback(e) {
      // Get map styles key.
      const key = e.detail.value;

      // Default map style to null.
      let mapStyle = null;

      // If there is a key, use it to find the map styles.
      if (key != null && key != '') {
        // Get map styles from key.
        mapStyle = this.mapStyles?.[key];
        if (!mapStyle) throw new Error(`Could not find map style for key ${key}`);

        // Set _name if missing (using label from $key).
        mapStyle._name ??= this.getMapStyleLabel(mapStyle);
        mapStyle._key = key;
      }

      // Set the default map styles.
      this.deepSet(`_itemData.map.default_map_styles`, mapStyle);
    }

    selectedChangedCallback(e) {
      // Make sure event detail is not nullish, and if not, update the property and clear the drop down.
      if (e?.detail?.value !== '' && e?.detail?.value != null) {
        this.updateProperty(e);
        e.currentTarget.clear();
      }
    }

    iconSelected(e) {
      // don't set an icon if we don't have on
      if (!e.detail.icon) return;
      // set the icon
      this.deepSet('_itemData.map.map_layers_default_icon.icon', e.detail.icon);
    }

    openIconDialog() {
      this.$.iconPickerDialog.open();
    }

    iconColorChanged(e) {
      // don't set a color if we don't have one
      if (!e.detail.value) return;
      // set the icon color
      this.deepSet('_itemData.map.map_layers_default_icon.color', e.detail.value);
    }

    computeSchema() {
      return {
        node: DEFAULT_SCHEMAS.NODE
      };
    }

    togglePublicFeedback(e) {
      const checked = e.target.checked;
      this.deepSet('_itemData.map.allow_public_feedback', checked);
    }
  }
);
